import React, { useEffect, useRef, useState } from "react";
import "react-alice-carousel/lib/alice-carousel.css";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import NoImageFoundDocument from "./noImageFoundDocument";

export default function UnionLoadDocument(props: any) {
  const images = props.data;
  const spanRef = useRef<HTMLSpanElement>(null);
  const [textWidth, setTextWidth] = useState(0);
  const [widthDiv, setWidthDiv] = useState<any>(0);

  // let isValue = false;
  // if (props.title! == true && props.data) {
  //     isValue = true
  // } else if (props.title! == false && props.data) {
  //     isValue = false
  // }
  const getTextWidthInPixels = (ref: HTMLSpanElement) =>
    ref.getBoundingClientRect().width;

  useEffect(() => {
    setTextWidth(getTextWidthInPixels(spanRef.current!));
  }, [spanRef]);

  let classText: any;
  if (textWidth > widthDiv) {
    classText = "paraghramImageUnion infoText";
  }

  const reference = React.useRef(null);
  const [dimensions, setDimensions] = useState<any>({ width: 0, height: 0 });
  useEffect(() => {
    if (reference.current) {
      setDimensions({
        width: reference?.current,
        height: reference.current,
      });
    }
    setWidthDiv(dimensions.width.offsetWidth);
  });
  return (
    <>
      {images[0] != null ? (
        <div className="UploadImageCmp" style={{ direction: "ltr" }}>
          <>
            {/* <a href={props.data.fileUrl!} target="_blank"> */}
            <Carousel showThumbs={false} showStatus={false} infiniteLoop={true}>
              {images?.map((image: any) =>
                image != undefined && image != null ? (
                  <>
                    <a
                      href={`${image.fileUrl}/true`}
                      target="blank"
                      style={{
                        maxWidth: "fit-content",
                        display: "inline-block",
                      }}
                    >
                      <img
                        src={image.fileUrl}
                        style={{ height: "14vh" }}
                        className="uploadImage"
                      />
                    </a>
                  </>
                ) : (
                  <div style={{ height: "14vh" }}>
                    {" "}
                    <NoImageFoundDocument border={"none"} />
                  </div>
                )
              )}
            </Carousel>

            {/* <img src={props.data.fileUrl} className="uploadImage" /> */}
            {/* </a> */}
            <div
              className="row unionRowUploadImage"
              style={{ direction: "rtl" }}
            >
              <div
                className="col-12 cont"
                style={{ color: "#fff" }}
                ref={reference}
              >
                <p className={classText ? classText : "paraghramImageUnion"}>
                  <span
                    ref={spanRef}
                    contentEditable
                    suppressContentEditableWarning
                    onInput={() =>
                      setTextWidth(getTextWidthInPixels(spanRef.current!))
                    }
                  >
                    {" تجمیعی "}
                    {props.accumulative.accumulativeAmount.toLocaleString()}
                    {" ریال "}
                  </span>
                </p>
              </div>
            </div>
          </>
        </div>
      ) : (
        <NoImageFoundDocument />
      )}
    </>
  );
}
